import React, { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '../store';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useStore((state) => state.user);
  const reset = useStore((state) => state.reset);

  const handleBack = () => {
    navigate(-1);
  };

  const handleLogout = () => {
    reset();
    navigate('/login');
  };

  const showBackButton = location.pathname !== '/bookings';

  return (
    <div className="min-h-screen bg-base-100">
      {/* Header */}
      <div className="navbar bg-primary text-primary-content sticky top-0 z-50">
        <div className="navbar-start">
          {showBackButton && (
            <button
              onClick={handleBack}
              className="btn btn-ghost btn-circle"
              aria-label="Go back"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
          )}
        </div>
        <div className="navbar-center">
          <span className="text-xl font-bold">Kano Lab 🚀</span>
        </div>
        <div className="navbar-end">
          <div className="dropdown dropdown-end">
            <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
              <div className="w-10 rounded-full">
                <div className="bg-primary-focus w-full h-full flex items-center justify-center">
                  {user?.name?.charAt(0).toUpperCase() || 'U'}
                </div>
              </div>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52 text-base-content"
            >
              <li>
                <span className="font-semibold">{user?.name || 'User'}</span>
              </li>
              <li>
                <button onClick={handleLogout}>Logout</button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="container mx-auto p-4 pb-20">
        {children}
      </main>
    </div>
  );
};

export default Layout;